import { t } from '@lingui/core/macro';
import { ScrollArea, Tooltip } from '@pocketlaw/tetris';
import { useScreenLayout } from './ScreenLayoutProvider';
import { useDraggableWidth } from './useDraggableWidth';
import { SidebarContainer, SidebarDraggableHover, SidebarDraggableLine, SidebarInnerContainer } from './styled';
export function Sidebar(props) {
    const { children } = props;
    const { sidebar } = useScreenLayout();
    const { dragging, onDraggableMouseDown } = useDraggableWidth();
    return (<SidebarContainer $open={sidebar.isOpen} $isDragging={dragging} ref={sidebar.sidebarRef}>
      <SidebarInnerContainer>
        <ScrollArea>{children}</ScrollArea>
      </SidebarInnerContainer>

      <Tooltip side="left" delay={1000} disabled={dragging} title={t({
            message: 'Drag to resize',
            comment: 'Sidebar - Resize tooltip label',
        })}>
        <SidebarDraggableHover $isDragging={dragging} onMouseDown={onDraggableMouseDown}>
          <SidebarDraggableLine />
        </SidebarDraggableHover>
      </Tooltip>
    </SidebarContainer>);
}
